import React from 'react';
import { HeroSection } from './HeroSection';
import { AuthFormSection } from './AuthFormSection';

export const AuthForm: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      {/* Mobile Layout - Modern, clean design */}
      <div className="lg:hidden min-h-screen flex flex-col">
        {/* Subtle gradient background */}
        <div className="absolute inset-0 bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-900 pointer-events-none" />
        
        {/* Content */}
        <div className="relative flex-1 flex flex-col">
          {/* Minimal Header - Mobile */}
          <div className="pt-8 pb-6 px-4">
            <div className="flex justify-center">
              <img 
                src="https://psezrfpnqxfxupfutlnq.supabase.co/storage/v1/object/public/assets/videreo_logo.png"
                alt="Videreo Logo" 
                className="h-8 w-auto"
              />
            </div>
          </div>
          
          {/* Auth Form - Mobile (centered, modern card design) */}
          <div className="flex-1 flex items-start justify-center px-4 pb-8">
            <div className="w-full max-w-md">
              <AuthFormSection idPrefix="mobile" />
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Layout - Two Column: Full experience */}
      <div className="hidden lg:flex min-h-screen">
        {/* Left Column - Full Hero (includes benefits, campaigns, social proof) */}
        <div className="flex-1 flex flex-col items-center">
          <HeroSection />
        </div>
        
        {/* Right Column - Auth Form */}
        <div className="flex-1 bg-white dark:bg-gray-900 flex flex-col">
          {/* Auth Form */}
          <div className="flex-1 flex items-center justify-center">
            <AuthFormSection idPrefix="desktop" />
          </div>
        </div>
      </div>
    </div>
  );
};